import SeriesProps from './SeriesProps'

let KendoSparklineSeriesItem = {
    name: 'kendo-sparkline-series-item',
    render () {
        return null
    },
    mixins: [SeriesProps]
}

export default KendoSparklineSeriesItem


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/KendoSparklineSeriesItem.js